module.exports = __webpack_public_path__ + "img/storm_commend_nodata.fc1ac7f4.png";